export const INNER = 'Inner List';
//# sourceMappingURL=INNER.js.map